import { applyHighlight, renderProductDownloads } from '../procenter/renderProductCard';
var FALLBACK_COVER = 'https://res.daetool.com/wm-static-resource/web/images/help/article-info-img2.png';
function escapeHtml(text) {
    return text
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
}
function toProductItem(row) {
    return {
        g_id: row.g_id,
        g_name: '',
        g_website: '',
        win32_url: row.win32_url,
        win64_url: row.win64_url,
        macM1_url: row.macM1_url,
        macIntel_url: row.macIntel_url,
        android_url: row.android_url,
        ios_url: row.ios_url,
    };
}
export function renderSearchManualCard(row, index, highlightKeyword) {
    var helpUrl = escapeHtml("".concat(row.details_url || '', "/help.html"));
    // 左侧封面与改版前一致：固定帮助占位图；i_url 为产品 logo，仅曾用于底栏小图标
    var cover = FALLBACK_COVER;
    var title = applyHighlight(row.title || '', highlightKeyword);
    var details = applyHighlight(row.details || '', highlightKeyword);
    var date = escapeHtml(row.create_time || '');
    var downloads = renderProductDownloads(toProductItem(row), "manual_".concat(index));
    return "<article class=\"daetool-search-result-manual-card\">\n    <a class=\"daetool-search-result-manual-card__cover\" href=\"".concat(helpUrl, "\" target=\"_blank\" rel=\"noopener\">\n      <img src=\"").concat(cover, "\" alt=\"\">\n    </a>\n    <div class=\"daetool-search-result-manual-card__main\">\n      <div class=\"daetool-search-result-manual-card__text\">\n        <h3 class=\"daetool-search-result-manual-card__title\">\n          <a href=\"").concat(helpUrl, "\" target=\"_blank\" rel=\"noopener\">").concat(title, "</a>\n        </h3>\n        <p class=\"daetool-search-result-manual-card__desc\">").concat(details, "</p>\n      </div>\n      <div class=\"daetool-search-result-manual-card__footer\">\n        <div class=\"daetool-procenter-container-list-down daetool-search-result-manual-card__downloads\">").concat(downloads, "</div>\n        <time class=\"daetool-search-result-manual-card__date\">").concat(date, "</time>\n      </div>\n    </div>\n  </article>");
}
export function renderSearchManualList(items, highlightKeyword) {
    var cards = items
        .map(function (item, i) { return renderSearchManualCard(item, i, highlightKeyword); })
        .join('');
    return "<div class=\"daetool-search-result-manual-list\">".concat(cards, "</div>");
}
